import { Download } from 'lucide-react';
import { CopyButton, StepBlock, VerifyStepShell } from './verifyShared';

export default function VerifyHtmlStep(props) {
  const { domain, instructions, onDownload, downloading } = props;
  const html = (instructions && instructions.html_file) || {};
  const fileUrl = html.url || `https://${domain}/acodia-verify-${(instructions || {}).token || ''}.html`;

  return (
    <VerifyStepShell title={`Verify ${domain} with an HTML file`}
                     autoNote="Auto-checking every 10 seconds…" {...props}>
      {/* STEP 1 — download */}
      <StepBlock n={1} title="Download the verification file">
        <button
          type="button"
          onClick={onDownload}
          disabled={downloading}
          data-testid="verify-html-download"
          className="font-body font-medium inline-flex items-center gap-2"
          style={{ padding: '0.7rem 1.3rem', borderRadius: 6, border: '1px solid var(--a-border)',
                   background: 'rgba(139,92,246,0.12)', color: 'var(--a-bright)',
                   cursor: downloading ? 'wait' : 'pointer' }}
        >
          <Download size={16} /> {downloading ? 'Preparing…' : `Download ${html.filename || 'verification file'}`}
        </button>
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.82rem', marginTop: '0.6rem' }}>
          Don&apos;t open it — just save it and upload as-is.
        </p>
      </StepBlock>

      {/* STEP 2 — upload */}
      <StepBlock n={2} title="Upload to the root of your website">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem',
                      border: '1px solid var(--b1)', borderRadius: 8, padding: '0.55rem 0.75rem',
                      background: 'var(--bg)' }}>
          <code style={{ fontFamily: 'ui-monospace, monospace', fontSize: '0.82rem',
                         color: 'var(--white)', flex: 1, wordBreak: 'break-all' }}>
            {fileUrl}
          </code>
          <CopyButton value={fileUrl} ariaLabel="Copy verification URL" />
        </div>
        <ul style={{ paddingLeft: '1.1rem', marginTop: '0.7rem', color: 'var(--tm)',
                     fontSize: '0.83rem', lineHeight: 1.7 }}>
          <li><strong>WordPress:</strong> Tools → File Manager, upload to <code>public_html/</code></li>
          <li><strong>cPanel:</strong> File Manager → <code>public_html/</code></li>
          <li><strong>Vercel:</strong> add to the <code>/public/</code> directory and deploy</li>
          <li><strong>Netlify:</strong> add to the root of your repo and deploy</li>
          <li><strong>Other:</strong> upload via FTP to your web root</li>
        </ul>
      </StepBlock>

      {/* STEP 3 — verify reachable */}
      <StepBlock n={3} title="Verify the file is reachable">
        <a href={fileUrl} target="_blank" rel="noreferrer"
           className="font-body font-medium inline-flex items-center gap-1.5"
           style={{ padding: '0.5rem 1rem', borderRadius: 6, border: '1px solid var(--b2)',
                    color: 'var(--white)', textDecoration: 'none', fontSize: '0.84rem' }}>
          Open verification URL ↗
        </a>
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.82rem', marginTop: '0.6rem' }}>
          If you see “Acodia domain verification — …”, you&apos;re ready. Come back here and click Check now.
        </p>
      </StepBlock>
    </VerifyStepShell>
  );
}
